import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailHistoryEntity } from './legacy-email-history.entity';

@Index('_fk__email_history__id', ['fkEmailHistoryId'], {})
@Entity('_email_history_recipient')
export class LegacyEmailHistoryRecipientEntity extends BaseEntity {
	@Column('int', { name: '_fk__email_history__id', unsigned: true })
	public fkEmailHistoryId!: number;

	@Column('varchar', { name: '_email', length: 255 })
	public email!: string;

	@Column('varchar', { name: '_type', length: 4 })
	public type!: string;

	@ManyToOne(
		() => LegacyEmailHistoryEntity,
		(emailHistory) => emailHistory.emailHistoryRecipients,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__email_history__id', referencedColumnName: 'id' }])
	public fkEmailHistory!: LegacyEmailHistoryEntity;
}
